var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_vm._m(0),_c('div',{staticClass:"footerBottom",class:{ indexFooter: _vm.isIndexGetter }})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footerContainer"},[_c('div',{staticClass:"footerTop"})])
}]

export { render, staticRenderFns }